import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as MenuItemsActions from './menu-items.actions'
import { MenuItemsEntity } from './menu-items.models'

export const MENU_ITEMS_FEATURE_KEY = 'menuItems'

export interface MenuItemsState extends EntityState<MenuItemsEntity> {
  selectedId?: string | number
  loaded: boolean
  editCreateLoaded: boolean
  resourcesLoaded: boolean
}

export interface MenuItemsPartialState {
  readonly [MENU_ITEMS_FEATURE_KEY]: MenuItemsState
}

export const menuItemsAdapter: EntityAdapter<MenuItemsEntity> = createEntityAdapter<MenuItemsEntity>({
  selectId: (menuItem: MenuItemsEntity) => menuItem.uuid,
})

export const initialMenuItemsState: MenuItemsState = menuItemsAdapter.getInitialState({
  loaded: true,
  editCreateLoaded: true,
  resourcesLoaded: true,
})

const reducer = createReducer(
  initialMenuItemsState,
  on(MenuItemsActions.loadMenuItems, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(MenuItemsActions.loadMenuItemsSuccess, (state, { menuItems }) =>
    menuItemsAdapter.setAll(menuItems, { ...state, loaded: true }),
  ),

  on(MenuItemsActions.selectMenuItem, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(MenuItemsActions.clearSelectMenuItem, (state) => ({
    ...state,
    selectedId: initialMenuItemsState.selectedId,
  })),
  on(MenuItemsActions.createMenuItem, (state) => ({ ...state, editCreateLoaded: false })),
  on(MenuItemsActions.createMenuItemSuccess, (state, { menuItem }) =>
    menuItemsAdapter.addOne(menuItem, { ...state, editCreateLoaded: true }),
  ),
  on(MenuItemsActions.createMenuItemFailure, (state) => ({ ...state, editCreateLoaded: true })),
  on(MenuItemsActions.updateMenuItem, (state) => ({ ...state, editCreateLoaded: false })),
  on(MenuItemsActions.updateMenuItemSuccess, (state, action) =>
    menuItemsAdapter.updateOne(action.update, { ...state, editCreateLoaded: true }),
  ),
  on(MenuItemsActions.updateMenuItemFailure, (state, action) => ({ ...state, editCreateLoaded: true })),
  on(MenuItemsActions.deleteMenuItemSuccess, (state, action) => menuItemsAdapter.removeOne(action.uuid, state)),
  on(MenuItemsActions.updateMenuItemOrderSuccess, (state, action) =>
    menuItemsAdapter.updateMany(action.menuItems, state),
  ),
  on(MenuItemsActions.loadMenuItemResources, (state) => ({
    ...state,
    resourcesLoaded: false,
  })),
  on(MenuItemsActions.loadMenuItemResourcesSuccess, (state) => ({
    ...state,
    resourcesLoaded: true,
  })),
  on(MenuItemsActions.loadMenuItemResourcesFailure, (state) => ({
    ...state,
    resourcesLoaded: true,
  })),
  on(MenuItemsActions.clearMenuItems, () => ({ ...initialMenuItemsState })),
)

export function menuItemsReducer(state: MenuItemsState | undefined, action: Action) {
  return reducer(state, action)
}
